import { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export default function GalleryModal({ isOpen, images, currentIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };

    if (isOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/95 backdrop-blur-md">
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-50 rounded-full bg-slate-900/80 p-3 text-white transition hover:bg-slate-800"
        aria-label="Luk galleri"
      >
        <X className="h-6 w-6" />
      </button>

      {/* Navigation buttons */}
      <button
        onClick={onPrev}
        className="absolute left-4 z-50 rounded-full bg-slate-900/80 p-3 text-white transition hover:bg-slate-800 md:left-8"
        aria-label="Forrige billede"
      >
        <ChevronLeft className="h-6 w-6" />
      </button>

      <button
        onClick={onNext}
        className="absolute right-4 z-50 rounded-full bg-slate-900/80 p-3 text-white transition hover:bg-slate-800 md:right-8"
        aria-label="Næste billede"
      >
        <ChevronRight className="h-6 w-6" />
      </button>

      {/* Image container */}
      <div className="relative max-h-[85vh] max-w-[90vw] overflow-hidden rounded-xl">
        <img
          src={images[currentIndex]}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-h-[85vh] max-w-[90vw] object-contain select-none"
        />
        
        {/* Caption */}
        <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-slate-950/80 to-transparent p-4 text-center text-sm text-slate-300">
          Billede {currentIndex + 1} af {images.length}
        </div>
      </div>
    </div>
  );
}
